import IconMore from "./IconMore";

export default function CardSpeaker({item, onClick, className= '',isOpen = true, ...rest}) {
    const hasLinks = item.links && item.links.length > 0;

    return (
        <div {...rest} className={`flex flex-row flex-1 rounded-40u border-3u border-[#A9AAB5] bg-[#0E2242] ${className}`} onClick={onClick}>
            <div className="flex-1 flex flex-col">
                <div className={`flex flex-col h-full
                font-extralight text-[5.75rem]
                leading-none
                ${!isOpen ? 'border-b-2u border-[#A9AAB5]' : ''}
                ${!isOpen ? 'px-63u pt-71u pb-61u' : 'pl-100u pt-108u pr-90u pb-82u'}
                relative
                `}>
                    <span
                        className={`block
                             ${!isOpen ? 
                            'text-32u mb-59u leading-43u' :
                            'text-32u mb-75u leading-48u'
                            }
                        `}
                        dangerouslySetInnerHTML={{__html:item.info}}></span>
                    <span className={`block mb-auto
                        ${!isOpen ?
                            'text-54u leading-64u' :
                            'text-72u leading-82u'
                        }
                        
                    `}
                    dangerouslySetInnerHTML={{__html:item.summary}}></span>
                    {item.speakers && item.speakers.map((speaker, index) => (
                    <div className="flex items-center mb-[2rem] last:mb-0" key={index}>
                        <img src={`${process.env.PUBLIC_URL}/speakers/${speaker.photo}`} alt={speaker.name}
                        className={`
                            rounded-full object-cover
                             ${!isOpen ? 'w-156u h-156u mr-36u' : 'w-212u h-212u mr-54u'}
                        `} />
                        <div className="flex flex-col">
                            <span className={`
                                block
                                ${!isOpen ? 'text-32u leading-42u' : 'text-42u leading-58u'}`}>
                                <b>{speaker.name}</b><br />
                                {speaker.position}
                            </span>
                        </div>
                    </div>
                    ))}
                </div>
                {!isOpen && (
                <div className="flex pr-57u pt-46u pb-50u text-24u leading-none items-center justify-end">
                    More information <IconMore className="w-[1.5rem] h-[1.5rem] ml-[0.8rem]" />
                </div>
                )}
            </div>
            {isOpen && (
            <div className="flex-0 w-1600u
                flex flex-col
                pt-122u px-166u
                border-l-3u border-[#A9AAB5]">
                <div className="
                min-h-[25.125rem]
                items-center
                text-36u leading-66u
                space-y-[3.75rem]"
                dangerouslySetInnerHTML={{__html:item.content}}
                >
                </div>
                {!!item.qr && (
                <img
                    src={`${process.env.PUBLIC_URL}/qr/${item.qr}`}
                    alt={item.qr_title}
                    className="w-277u h-277u object-cover rounded-10u mt-100u"
                />   
                )}
            </div>
            )}
        </div>
    );
};